export default __webpack_public_path__ + "static/media/placeholder-round.9d663213.svg";